export default __webpack_public_path__ + "static/media/Yellow0004.cc4bba03.png";